import React, { useEffect, useState } from 'react';

import styles from './HealthCardHdPopulation.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../../Auth';
import { useAxios } from '../../../../../../../AxiosHandler';
import LineGraphCard from '../../../../Cards/LineGraphCard/LineGraphCard';

function HealthCardHdPopulation(props: HealthCardHdPopulationProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();
    
    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/hd/breed/" + auth.selectedBreed + "/population",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            let dataSets = [
                { label: "A", color: "#68DB5A" },
                { label: "B", color: "#A6F65D" },
                { label: "C", color: "#FFE144" },
                { label: "D", color: "#F89D27" },
                { label: "E", color: "#FF2F45" },
                { label: t("statistics.areas.health.graphs.hd.population.not_checked"), color: "#FF2F45" }
            ]

            if (res.data?.length > 0) {
                setData({
                    labels: res.data.map((i: any) => i["YEAR"]),
                    datasets: dataSets.map((i: any) => {
                        return {
                            label: i.label,
                            backgroundColor: "transparent",
                            pointBackgroundColor: i.color,
                            borderColor: i.color,
                            pointRadius: 2,
                            data: res.data.map((j: any) => j[i.label]),
                            tension: 0.5
                        }
                    })
                });
            } else {
                setData(undefined);
            }
            
            props.onDataLoaded?.(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticshealth} style={{ display: data == undefined || data.length == 0 ? "none" : "block" }}>
            <LineGraphCard
                title={t("statistics.areas.health.graphs.hd.population.title")}
                data={data}
                description={t("statistics.areas.health.graphs.hd.population.description")}
            ></LineGraphCard>
        </div>
    );
}

class HealthCardHdPopulationProps {
    onDataLoaded?: (data: any) => void;
}

export default HealthCardHdPopulation;